import { render, staticRenderFns } from "./userSearch.vue?vue&type=template&id=68a49189&scoped=true&"
import script from "./userSearch.vue?vue&type=script&lang=js&"
export * from "./userSearch.vue?vue&type=script&lang=js&"
import style0 from "./userSearch.vue?vue&type=style&index=0&id=68a49189&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a49189",
  null
  
)

export default component.exports